import * as TYPES from './type';
export default {
  //课中活动测验
  [TYPES.TEST_LIST](state, { result }) {
    state.testList = result.result
  },
  [TYPES.TEST_INFO](state, { result, type }) {
    state.testInfo[type] = result.result
  },
}


// WEBPACK FOOTER //
// ./src/store/kzActivity/test/mutations.js